import { render, staticRenderFns } from "./HelpTip.vue?vue&type=template&id=472d4eb9"
import script from "./HelpTip.vue?vue&type=script&lang=js"
export * from "./HelpTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports